// Exports the "help" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/help')
//   ES2015:
//     import 'tinymce/plugins/help'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/help/index.js
// module id = 4YQI
// module chunks = 1